program Login_TEKNIA;

{$R *.dres}

uses
  Vcl.Forms,
  WEBLib.Forms,
  Login_View in 'Login_View.pas'{*.html},
  Home_View in 'Home_View.pas'{*.html};

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TLoginView, LoginView);
  Application.CreateForm(THomeView, HomeView);
  Application.Run;
end.
